/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { AddAthleteEventModalComponent } from './add-athlete-event-modal/add-athlete-event-modal.component';
import { AddAthleteModalComponent } from './add-athlete-modal/add-athlete-modal.component';
import { BreakdownInfoModalComponent } from './breakdown-info-modal/breakdown-info-modal.component';
import { ClipFilteringModalComponent } from './clip-filtering-modal/clip-filtering-modal.component';
import { LibraryClipFilteringModalComponent } from './library-clip-filtering-modal/library-clip-filtering-modal.component';
import { CompleteProfileModalComponent } from './complete-profile-modal/complete-profile-modal.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { DownloadModalComponent } from './download-modal/download-modal.component';
import { HighlightReelPlayProModalComponent } from './highlight-reel-play-pro-modal/highlight-reel-play-pro-modal.component';
import { HighlightReelPlaySelectModalComponent } from './highlight-reel-play-select-modal/highlight-reel-play-select-modal.component';
import { HighlightReelUploadModalComponent } from './highlight-reel-upload/highlight-reel-upload.component';
import { HrSelectionModalComponent } from './hr-selection-modal/hr-selection-modal.component';
import { InvitePendingModalComponent } from './invite-pending-modal/invite-pending-modal.component';
import { LoginModalComponent } from './login-modal/login-modal.component';
import { OrderModalComponent } from './order-modal/order-modal.component';
import { ProfileContactModalComponent } from './profile-contact-modal/profile-contact-modal.component';
import { ProfilePhotoCropModalComponent } from './profile-photo-crop-modal/profile-photo-crop-modal.component';
import { ProfileVideoModalComponent } from './profile-video-modal/profile-video-modal.component';
import { SetupAccountModalComponent } from './setup-account-modal/setup-account-modal.component';
import { TeamSelectionModalComponent } from './team-selection-modal/team-selection-modal.component';
import { UserArticleModalComponent } from './user-article-modal/user-article-modal.component';
import { UserCommitmentModalComponent } from './user-commitment-modal/user-commitment-modal.component';
import { UserEventModalComponent } from './user-event-modal/user-event-modal.component';
import { IgShareModalComponent } from './ig-share-modal/ig-share-modal.component';
import { GameUploadModalComponent } from './game-upload-modal/game-upload-modal.component';

export * from './add-athlete-event-modal/add-athlete-event-modal.component';
export * from './add-athlete-modal/add-athlete-modal.component';
export * from './breakdown-info-modal/breakdown-info-modal.component';
export * from './clip-filtering-modal/clip-filtering-modal.component';
export * from './library-clip-filtering-modal/library-clip-filtering-modal.component';
export * from './complete-profile-modal/complete-profile-modal.component';
export * from './confirmation-modal/confirmation-modal.component';
export * from './highlight-reel-play-pro-modal/highlight-reel-play-pro-modal.component';
export * from './highlight-reel-play-select-modal/highlight-reel-play-select-modal.component';
export * from './highlight-reel-upload/highlight-reel-upload.component';
export * from './hr-selection-modal/hr-selection-modal.component';
export * from './invite-pending-modal/invite-pending-modal.component';
export * from './game-upload-modal/game-upload-modal.component';
export * from './login-modal/login-modal.component';
export * from './order-modal/order-modal.component';
export * from './profile-contact-modal/profile-contact-modal.component';
export * from './profile-photo-crop-modal/profile-photo-crop-modal.component';
export * from './profile-video-modal/profile-video-modal.component';
export * from './setup-account-modal/setup-account-modal.component';
export * from './team-selection-modal/team-selection-modal.component';
export * from './download-modal/download-modal.component';
export * from './user-article-modal/user-article-modal.component';
export * from './user-commitment-modal/user-commitment-modal.component';
export * from './user-event-modal/user-event-modal.component';
export * from './ig-share-modal/ig-share-modal.component';

export const modalComponents: any[] = [
  AddAthleteEventModalComponent,
  AddAthleteModalComponent,
  BreakdownInfoModalComponent,
  ClipFilteringModalComponent,
  LibraryClipFilteringModalComponent,
  CompleteProfileModalComponent,
  ConfirmationModalComponent,
  HighlightReelPlayProModalComponent,
  HighlightReelPlaySelectModalComponent,
  HighlightReelUploadModalComponent,
  HrSelectionModalComponent,
  InvitePendingModalComponent,
  LoginModalComponent,
  OrderModalComponent,
  ProfileContactModalComponent,
  ProfilePhotoCropModalComponent,
  ProfileVideoModalComponent,
  SetupAccountModalComponent,
  TeamSelectionModalComponent,
  DownloadModalComponent,
  UserArticleModalComponent,
  UserCommitmentModalComponent,
  UserEventModalComponent,
  IgShareModalComponent,
  GameUploadModalComponent,
];
